module.exports = __webpack_public_path__ + "img/hand.f43a0411.svg";